import camelCase from 'lodash/camelCase';
import { store } from 'src/common/redux/configure-store';
import { IDeviceConfigurationDictionary } from 'src/device-status/interfaces/IDeviceConfigurationDictionary';
import { ConfigOptions } from './dtos/eps-data';

export const hasRpsPinpadDevice = (): boolean => !!getPinPadConfig();

export const getPinPadConfig = (): IDeviceConfigurationDictionary | undefined => {
  return store.getState().pinPad.configuration;
};

export const parsePinpadConfig = (
  configDictionary?: IDeviceConfigurationDictionary,
): ConfigOptions => {
  const trainingMode = store.getState().posMode.trainingMode;
  const config: ConfigOptions = {
    companyNumber: 0,
    configAddress: '',
    configPort: 0,
    clientKey: '',
    secretKey: '',
    hostAddress: '',
    hostAddressSecondary: '',
    hostPort: 0,
    hostPortSecondary: 0,
    laneNumber: 0,
    maxOfflineTransactionAmount: 0,
    maxOfflineTransactions: 0,
    maxTotalOfflineAmount: 0,
    promptTip: false,
    storeNumber: 0,
  };
  for (const property in configDictionary) {
    const key = camelCase(property);
    if (key in config) {
      config[key] = configDictionary[property];
    }
  }
  if (trainingMode && configDictionary?.TestStoreNumber) {
    config.storeNumber = Number(configDictionary.TestStoreNumber);
  }
  return config;
};
